/**
 * Markdown often turns `/api/reporting/...` into `<a href>`, which triggers GET navigations / prefetches.
 * Replace those anchors with non-navigable spans so only POST (ask) / explicit session GETs hit the API.
 */
function escapeHtmlAttributeValue(text: string): string {
  return text.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/"/g, '&quot;');
}

export function stripNavigableReportingApiLinks(html: string): string {
  return html.replace(/<a\b[^>]*\bhref=["']([^"']*)["'][^>]*>([\s\S]*?)<\/a>/gi, (full, href: string) => {
    if (!href.includes('/api/reporting/')) {
      return full;
    }
    const safe = escapeHtmlAttributeValue(href);
    return `<span data-le-data-api-path="1"><code>${safe}</code></span>`;
  });
}
